export default "__VITE_PUBLIC_ASSET__9eb02819__"